import { Link } from './utils/SmartLink'
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const FancyStandard = styled.div`
  padding: .5rem;
  border: 1px solid black;
  margin-bottom: 2px;
  border-radius: 5px;
`

export const StandardLink = ({ code, label }) => {
  return (
    <Link to={`/gse/${code}`} >
      <FancyStandard>
        { label || code }
      </FancyStandard>
    </Link>
  )
}

StandardLink.propTypes = {
  label: PropTypes.string,
  code: PropTypes.string
}
